/** Misma lógica que Legalmente / Hoet: encabezados legibles en light y dark. */
export function readableHeading(theme) {
  return theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main;
}
